import { render, staticRenderFns } from "./CommunityBusinessnewsDetail.vue?vue&type=template&id=5bea28b9&scoped=true&"
import script from "./CommunityBusinessnewsDetail.vue?vue&type=script&lang=js&"
export * from "./CommunityBusinessnewsDetail.vue?vue&type=script&lang=js&"
import style0 from "./CommunityBusinessnewsDetail.vue?vue&type=style&index=0&id=5bea28b9&prod&scoped=true&lang=css&"
import style1 from "./CommunityBusinessnewsDetail.vue?vue&type=style&index=1&id=5bea28b9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bea28b9",
  null
  
)

export default component.exports